import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.updateCount()

        document.addEventListener('filters-changed', () => {
            this.updateCount()
        })
    }

    disconnect() {
        document.removeEventListener('filters-changed', () => {})
    }

    updateCount() {
        const filters = document.querySelectorAll('#filter');

        let appliedCount = 0;
        filters.forEach(filter => {
            const list = filter.querySelector('[data-multi-value-input-target="list"]');

            if (list && list.children.length > 0) {
                appliedCount += 1;
            }
        });

        let resetFiltersBtn = document.querySelector('#reset_filters');
        if (appliedCount > 0) {
            resetFiltersBtn.innerHTML = 'Reset all filters';
        } else if (appliedCount === 0) {
            resetFiltersBtn.innerHTML = 'No filters applied';
        }


        if (appliedCount > 0) {
            document.querySelector('#applied-filters-count').textContent = `${appliedCount} filters applied`;
        } else if (appliedCount === 0) {
            document.querySelector('#applied-filters-count').textContent = '';
        }
    }
}
